import { instance } from '@/libs/api/instance'

export const getSessions = async () => {
  return instance.get('/v2/auth')
}
